import { css } from "@emotion/react"

export const mainContainer = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 16px;
    margin: 5px 0px;

    border: 1px solid #dbdbdb;
    border-radius: 4px;
    background-color: #fff;
`

export const header = css`

`

export const icon = (id) => css`
    font-size: 12px;
    margin-right: 3px;
    color: ${id === 'sohou_layer' ? '#0000FF' : id === 'mohou_layer' ? '#00FF00' : 'rgb(128, 128, 128)'};
`

export const type = css`
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    color: #808080;
`

export const typeText = css`
    color: #808080;
    font-size: 10px;
`

export const nameText = css`
    font-size: 14px;
`

export const buttonContainer = css`
    display: flex;
    align-items: center;
`

export const button = css`
    display: flex;
    align-items: center;
    text-align: center;
    padding: 5px;
    font-size: 18px;
    color: #808080;
    background-color: transparent;
    border: none;

    &:hover {
        background-color: #EEEEEE;
    }

    cursor: pointer;
`

export const hover = (hover) => css`
    opacity: ${hover ? 1 : 0};

    transition: opacity 0.5s ease;
`